module.exports = __webpack_public_path__ + "static/hero_bg_lg-082478ecdadfddae4db1f6116d78bae2.jpg";